module.exports = __webpack_public_path__ + "img/IconBloodSugarControl.72b296b2.svg";